/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  TimesIcon,
  ResetIcon,
  PrevIcon,
  NextIcon,
  CompleteIcon,
  ShowAnswerIcon,
} from '@/icons/ActivityToolsIcon';
import { useEffect, useState } from 'react';
import { DisplayTypes, PageItemCanvasModel, SbPageItemType } from '@/types';

interface ActivityToolsProps {
  dispatch: (action: any) => void;
  currentPageItem:PageItemCanvasModel;
  setDisplayType: (type: DisplayTypes) => void;
  completeActivity: () => void;
  resetActivity: () => void;
  showActivityAnswer: () => void;
  showPreviousAnswer: () => void;
  showNextAnswer: () => void;
}

const ActivityTools: React.FC<ActivityToolsProps> = (props) => {
  const {
    dispatch,
    currentPageItem,
    setDisplayType,
    completeActivity,
    resetActivity,
    showActivityAnswer,
    showPreviousAnswer,
    showNextAnswer,
  } = props;
  
  const [isMobile, setIsMobile] = useState<boolean>(false);
  
  // Ekran boyutunu kontrol edelim
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  
  return (
    <div className={`activity-content-tools ${isMobile ? 'mobile-activity-tools' : ''}`} style={{zIndex: 2000}}>
      <button
        className="activity-button red"
        onClick={() => {
          dispatch(setDisplayType(DisplayTypes.Page));
        }}
      >
        <TimesIcon />
      </button>
      {currentPageItem.sources &&
        currentPageItem.sources.length > 0 && (
          <>
            <button
              className="activity-button purple"
              onClick={() => {
                setTimeout(() => {
                  showPreviousAnswer();
                }, 150);
              }}
            >
              <PrevIcon />
            </button>
            <button
              className="activity-button purple"
              onClick={() => {
                setTimeout(() => {
                  showNextAnswer();
                }, 150);
              }}
            >
              <NextIcon />
            </button>
            <button
              className="activity-button yellow"
              onClick={() => {
                setTimeout(() => {
                  showActivityAnswer();
                }, 150);
              }}
            >
              <ShowAnswerIcon />
            </button>
            <button
              className="activity-button blue"
              onClick={() => {
                setTimeout(() => {
                  resetActivity();
                }, 150);
              }}
            >
              <ResetIcon />
            </button>
          </>
        )}
      {currentPageItem.hasCompleteButton &&
        (currentPageItem.pageItemType !== SbPageItemType.Underline) && (
          <button
            className="activity-button green"
            onClick={() => {
              setTimeout(() => {
                completeActivity();
              }, 150);
            }}
          >
            <CompleteIcon />
          </button>
        )}
    </div>
  );
};

export default ActivityTools;
